import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"

// Create Class
export const createCategory = data => post(url.CREATE_CATEGORY, data);
export const updateCategory = data => put(url.UPDATE_CATEGORY, data);
export const deleteCategory = id => del(url.DELETE_CATEGORY + id);
export const fetchAllCategory = () => get(url.FETCH_ALL_CATEGORY);